import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import {
  fetchCustomers,
  deleteCustomer,
  clearError,
} from '../features/customers/customersSlice';
import { fetchMigrationCategories } from '../features/customers/customersAPI';

export default function CustomersList() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { customers, total, page, totalPages, limit, status, error } = useSelector(
    (state) => state.customers
  );

  const [filters, setFilters] = useState({
    status: '',
    search: '',
    migration_category: '',
  });
  const [deleteConfirm, setDeleteConfirm] = useState(null);
  const [migrationCategories, setMigrationCategories] = useState([]);

  useEffect(() => {
    dispatch(fetchCustomers({ page: 1, limit, filters: {} }));
    
    // Fetch migration categories
    fetchMigrationCategories()
      .then(categories => setMigrationCategories(categories))
      .catch(err => console.error('Error fetching migration categories:', err));
  }, [dispatch]);

  const handleSearch = (e) => {
    e.preventDefault();
    dispatch(fetchCustomers({ page: 1, limit, filters }));
  };

  const handleFilterChange = (key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  };

  const handlePageChange = (newPage) => {
    dispatch(fetchCustomers({ page: newPage, limit, filters }));
  };

  const handleDelete = async (id) => {
    if (deleteConfirm === id) {
      await dispatch(deleteCustomer(id));
      setDeleteConfirm(null);
      dispatch(fetchCustomers({ page, limit, filters }));
    } else {
      setDeleteConfirm(id);
      setTimeout(() => setDeleteConfirm(null), 3000);
    }
  };

  const handleClearError = () => {
    dispatch(clearError());
  };

  const primaryColor = '#05aa4be6';

  const resolveInstanceName = (customer) => {
    if (customer?.instance && typeof customer.instance === 'object') {
      return customer.instance.name || 'N/A';
    }
    return customer?.instance_name || 'N/A';
  };

  const resolveDatabaseCluster = (customer) => {
    if (customer?.database && typeof customer.database === 'object') {
      return customer.database.cluster || 'N/A';
    }
    return customer?.database_cluster || 'N/A';
  };

  return (
    <div className="container-fluid">
      {/* <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 style={{ color: primaryColor, fontWeight: '600', marginBottom: 0 }}>Customers</h2>
        <Link
          to="/customers/new"
          className="btn btn-lg text-white shadow-sm d-flex align-items-center gap-2"
          style={{
            backgroundColor: primaryColor,
            border: 'none',
            borderRadius: '0.5rem'
          }}
        >
          <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
            <path d="M8 0a1 1 0 0 1 1 1v6h6a1 1 0 1 1 0 2H9v6a1 1 0 1 1-2 0V9H1a1 1 0 0 1 0-2h6V1a1 1 0 0 1 1-1z"/>
          </svg>
          Add Customer
        </Link>
      </div> */}

      {error && (
        <div className="alert alert-danger alert-dismissible d-flex align-items-center" role="alert" style={{ borderRadius: '0.5rem' }}>
          <svg width="20" height="20" viewBox="0 0 16 16" fill="currentColor" className="me-2">
            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
            <path d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z"/>
          </svg>
          <div>{error}</div>
          <button
            type="button"
            className="btn-close"
            onClick={handleClearError}
          ></button>
        </div>
      )}

      {/* Filters */}
      <div className="card border-0 shadow-sm mb-3" style={{ borderRadius: '0.5rem' }}>
        <div className="card-body">
          <h6 className="mb-3 d-flex align-items-center gap-2" style={{ color: primaryColor }}>
            <svg width="18" height="18" viewBox="0 0 16 16" fill="currentColor">
              <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
            </svg>
            Search & Filter
          </h6>
          <form onSubmit={handleSearch}>
            <div className="row g-3">
              <div className="col-md-4">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search by customer, subdomain, instance, database..."
                  value={filters.search}
                  onChange={(e) => handleFilterChange('search', e.target.value)}
                  style={{ borderRadius: '0.5rem' }}
                />
              </div>
              <div className="col-md-3">
                <select
                  className="form-select"
                  value={filters.migration_category}
                  onChange={(e) => handleFilterChange('migration_category', e.target.value)}
                  style={{ borderRadius: '0.5rem' }}
                >
                  <option value="">All Categories</option>
                  {migrationCategories.map((category) => (
                    <option key={category} value={category}>
                      {category}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-md-2">
                <button type="submit" className="btn w-100 text-white" style={{ backgroundColor: primaryColor, border: 'none', borderRadius: '0.5rem' }}>
                  Search
                </button>
              </div>
              <div className="col-md-3">
                <button
                  type="button"
                  className="btn btn-outline-secondary w-100"
                  onClick={() => {
                    setFilters({ status: '', search: '', migration_category: '' });
                    dispatch(fetchCustomers({ page: 1, limit, filters: {} }));
                  }}
                  style={{ borderRadius: '0.5rem' }}
                >
                  Clear
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>

      {/* Results Info */}
      <div className="mb-3">
        <small className="text-muted">
          Showing <strong>{customers.length}</strong> of <strong>{total}</strong> customers
          {filters.search && ` (filtered)`}
        </small>
      </div>

      {/* Table */}
      {status === 'loading' ? (
        <div className="card border-0 shadow-sm" style={{ borderRadius: '0.5rem' }}>
          <div className="card-body text-center py-5">
            <div className="spinner-border" style={{ color: primaryColor }} role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="mt-3 text-muted">Loading customers...</p>
          </div>
        </div>
      ) : customers.length === 0 ? (
        <div className="alert alert-info d-flex align-items-center" style={{ borderRadius: '0.5rem' }}>
          <svg width="20" height="20" viewBox="0 0 16 16" fill="currentColor" className="me-2">
            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
            <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>
          </svg>
          <div>
            No customers found. {filters.search && 'Try adjusting your search filters.'}
          </div>
        </div>
      ) : (
        <div className="card border-0 shadow-sm" style={{ borderRadius: '0.5rem' }}>
          <div className="table-responsive">
            <table className="table table-hover mb-0">
              <thead style={{ backgroundColor: '#f8f9fa' }}>
                <tr>
                  <th style={{ color: '#6c757d', fontWeight: '600' }}>Customer Name</th>
                  <th style={{ color: '#6c757d', fontWeight: '600' }}>Subdomain</th>
                  {/* <th style={{ color: '#6c757d', fontWeight: '600' }}>CNAME</th> */}
                  <th style={{ color: '#6c757d', fontWeight: '600' }}>Instance Name</th>
                  <th style={{ color: '#6c757d', fontWeight: '600' }}>Database Cluster</th>
                  <th style={{ color: '#6c757d', fontWeight: '600' }}>Migration Category</th>
                  <th style={{ color: '#6c757d', fontWeight: '600' }}> Created At</th>
                  <th style={{ color: '#6c757d', fontWeight: '600' }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {customers.map((customer) => (
                  <tr key={customer._id}>
                    <td>{customer.customer}</td>
                    <td>
                      <code style={{ backgroundColor: '#f1f3f5', padding: '0.25rem 0.5rem', borderRadius: '0.25rem' }}>{customer.subdomain}</code>
                    </td>
                    {/* <td>
                      <small className="text-muted">{customer.cname}</small>
                    </td> */}
                    <td>{resolveInstanceName(customer)}</td>
                    <td>
                      {/* <span
                        className="badge"
                        style={{
                          backgroundColor: customer.status === 'active' ? primaryColor : customer.status === 'inactive' ? '#6c757d' : '#ffc107',
                          borderRadius: '0.5rem',
                          padding: '0.35rem 0.75rem'
                        }}
                      >
                        {customer.database_cluster}
                      </span> */}
                      {resolveDatabaseCluster(customer)}
                    </td>
                    <td>
                      <span
                        className="badge"
                        style={{
                          backgroundColor: '#e3f2fd',
                          color: '#1976d2',
                          borderRadius: '0.5rem',
                          padding: '0.35rem 0.75rem'
                        }}
                      >
                        {customer.migration_category || 'N/A'}
                      </span>
                    </td>
                    <td>{new Date(customer.created_at).toLocaleDateString()} {new Date(customer.created_at).toLocaleTimeString()}</td>
                    <td>
                      <div className="d-flex gap-2">
                        <button
                          className="btn btn-sm btn-outline-secondary"
                          onClick={() => navigate(`/customers/${customer._id}`)}
                          style={{ borderRadius: '0.5rem' }}
                        >
                          <svg width="14" height="14" viewBox="0 0 16 16" fill="currentColor">
                            <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z"/>
                            <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z"/>
                          </svg>
                        </button>
                        {/* <button
                          className="btn btn-sm text-white"
                          onClick={() => navigate(`/customers/${customer._id}/edit`)}
                          style={{ backgroundColor: primaryColor, border: 'none', borderRadius: '0.5rem' }}
                        >
                          <svg width="14" height="14" viewBox="0 0 16 16" fill="currentColor">
                            <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z"/>
                          </svg>
                        </button>
                        <button
                          className={`btn btn-sm ${deleteConfirm === customer._id ? 'btn-danger' : 'btn-outline-danger'}`}
                          onClick={() => handleDelete(customer._id)}
                          style={{ borderRadius: '0.5rem' }}
                        >
                          {deleteConfirm === customer._id ? (
                            'Confirm?'
                          ) : (
                            <svg width="14" height="14" viewBox="0 0 16 16" fill="currentColor">
                              <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>
                              <path fillRule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/>
                            </svg>
                          )}
                        </button> */}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Pagination */}
      {totalPages > 1 && (
        <nav className="mt-4">
          <ul className="pagination justify-content-center">
            <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
              <button
                className="page-link"
                onClick={() => handlePageChange(page - 1)}
                disabled={page === 1}
                style={{ borderRadius: '0.5rem 0 0 0.5rem', color: page === 1 ? '#6c757d' : primaryColor }}
              >
                <svg width="14" height="14" viewBox="0 0 16 16" fill="currentColor">
                  <path fillRule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/>
                </svg>
              </button>
            </li>
            {(() => {
              const maxVisible = 5;
              let startPage = Math.max(1, page - Math.floor(maxVisible / 2));
              let endPage = Math.min(totalPages, startPage + maxVisible - 1);

              if (endPage - startPage < maxVisible - 1) {
                startPage = Math.max(1, endPage - maxVisible + 1);
              }

              const pages = [];

              if (startPage > 1) {
                pages.push(
                  <li key={1} className="page-item">
                    <button className="page-link" onClick={() => handlePageChange(1)} style={{ color: primaryColor }}>
                      1
                    </button>
                  </li>
                );
                if (startPage > 2) {
                  pages.push(
                    <li key="ellipsis-start" className="page-item disabled">
                      <span className="page-link">...</span>
                    </li>
                  );
                }
              }

              for (let p = startPage; p <= endPage; p++) {
                pages.push(
                  <li key={p} className={`page-item ${page === p ? 'active' : ''}`}>
                    <button
                      className="page-link"
                      onClick={() => handlePageChange(p)}
                      style={{
                        backgroundColor: page === p ? primaryColor : 'transparent',
                        borderColor: page === p ? primaryColor : '#dee2e6',
                        color: page === p ? 'white' : primaryColor
                      }}
                    >
                      {p}
                    </button>
                  </li>
                );
              }

              if (endPage < totalPages) {
                if (endPage < totalPages - 1) {
                  pages.push(
                    <li key="ellipsis-end" className="page-item disabled">
                      <span className="page-link">...</span>
                    </li>
                  );
                }
                pages.push(
                  <li key={totalPages} className="page-item">
                    <button className="page-link" onClick={() => handlePageChange(totalPages)} style={{ color: primaryColor }}>
                      {totalPages}
                    </button>
                  </li>
                );
              }

              return pages;
            })()}
            <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
              <button
                className="page-link"
                onClick={() => handlePageChange(page + 1)}
                disabled={page === totalPages}
                style={{ borderRadius: '0 0.5rem 0.5rem 0', color: page === totalPages ? '#6c757d' : primaryColor }}
              >
                <svg width="14" height="14" viewBox="0 0 16 16" fill="currentColor">
                  <path fillRule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                </svg>
              </button>
            </li>
          </ul>
        </nav>
      )}
    </div>
  );
}
